/**
 * Houses quick-views, which are buttons that can change quickly change filters and settings to capture/debug a common problem.
 */
import React, { Component } from "react";
import LoggerButton from "../../../LoggerButton";
import LoggerStore from "../../../../stores/LoggerStore";

class QuickViews extends Component {
	render() {
		return (
			<div className="quick-views logger-row">
				Quick views
				<div className="fsbl-logger-buttons">
					<LoggerButton
						title="CTRL+ALT+E"
						className="logger-button-margin-left"
						onClick={LoggerStore.configureLoggerForErrors}
					>
						Errors Only
					</LoggerButton>
					<LoggerButton
						title="CTRL+ALT+D"
						className="logger-button-margin-left"
						onClick={LoggerStore.configureLoggerForDefaults}
					>
						Default
					</LoggerButton>
					<LoggerButton
						title="CTRL+ALT+S"
						className="logger-button-margin-left"
						onClick={LoggerStore.configureLoggerForFieldCapture}
					>
						Finsemble Support
					</LoggerButton>
				</div>
			</div>
		);
	}
}

export default QuickViews;
